import React, { useEffect, useState } from 'react'
import axios from 'axios';
import Loading from '../Loading/Loading.jsx';
import { corseLink, notionApiHeaders, notionApiLink } from '../constant.js';

export default function SkillsList() {

    const [skills, setSkills] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getSkillsIcon = async () => {
            try {
                setLoading(true);
                const response = await axios.post(
                    corseLink + notionApiLink("1b911e5fc81180f1b7abd0b7999041eb"),
                    {},
                    {
                        headers: notionApiHeaders,
                    }
                );
                // console.log("Response results:", response);
                const skillsList = [];
                response.data.results.forEach(item => {
                    skillsList.push({
                        name: item.properties.Name.title[0].plain_text,
                        iconUrl: item.properties.icon.files[0].file.url,
                    })
                });
                setSkills(skillsList);
                // console.log("skillsList:", skillsList);
            } catch (error) {
                console.log("Error:", error);
            }
            setLoading(false);
        };
        getSkillsIcon();
    }, []);


    if(loading) return <div className='w-full flex justify-center'>
        <Loading />
    </div>


    // return (
    //     <div className='flex flex-wrap justify-center gap-4 mt-5'>
    //         {skills.map((skill, index) => <div key={index} className='flex flex-col items-center justify-center px-5 py-1'>
    //             <div className='w-12 h-12'>
    //                 <img src={skill.iconUrl} alt={skill.name} className='object-contain w-full h-full' />
    //             </div>
    //             <p className='text-[#19284D]'>{skill.name}</p>
    //         </div>)}
    //     </div>
    // );

    return (
        <div className='grid grid-cols-12 gap-4 mt-5'>
            {skills.map((skill, index) => <div key={index} className='col-span-4 sm:col-span-3 md:col-span-4 lg:col-span-2 flex flex-col items-center justify-center'>
                <div className='w-12 h-12'>
                    <img src={skill.iconUrl} alt={skill.name} className='object-contain w-full h-full' />
                </div>
                <p className='text-[#19284D]'>{skill.name}</p>
            </div>)}
        </div>
    );
}
